import React from "react";
import { Link } from "react-router-dom";
import Icon from "../components/Icon";
import { ourBrand } from "../data/siteData";
import "../styles/OurBrand.css";
import logo from "../assets/studio.png";

export default function OurBrand() {
  return (
    <div className="tp-brand">
      {/* ---------------- Hero ---------------- */}
      <section className="tp-brand-hero tp-floral-bg ">
        <div className="tp-container tp-home-hero__stage tp-brand_center">
          <div>
            <span className="tp-brand-hero__mark">
              {/* <Icon name="leaf" size={26} /> */}
              <img src={logo} alt="Terra Bloom Studio" />
            </span>
          </div>

          {/* <span
            className="tp-eyebrow"
            style={{ display: "block", textAlign: "center" }}
          >
            {ourBrand.story.eyebrow}
          </span> */}
          <p className="tp-brand-story__body">{ourBrand.story.body}</p>
        </div>
      </section>

      {/* ---------------- Brand Story ---------------- */}
      <section className="tp-section tp-section--tight tp-brand-story">
        <div className="tp-container">
          <div className="tp-section tp-brand-identity">
            {/* <span className="tp-eyebrow tp-brand-identity__eyebrow">
              <Icon name="leaf" size={14} /> {ourBrand.eyebrow}{" "}
              <Icon name="leaf" size={14} />
            </span> */}
            <h2 className="tp-brand-mission__heading">{ourBrand.eyebrow}</h2>

            <div className="tp-brand-identity__row">
              {ourBrand.identity.map((item) => (
                <div className="tp-brand-identity__item" key={item.label}>
                  <span
                    className={`tp-brand-identity__icon tp-brand-identity__icon--${item.tone}`}
                  >
                    <Icon name={item.icon} size={24} />
                  </span>
                  <p>{item.label}</p>
                </div>
              ))}
            </div>
          </div>

          {/* <span className="tp-eyebrow tp-brand-mission__label">
            {ourBrand.story.brandLabel}
          </span> */}

          <div className="tp-brand-story__grid">
            {ourBrand.story.items.map((item) => (
              <div className="tp-brand-story__card" key={item.text}>
                <span className="tp-brand-story__icon">
                  {/* <Icon name={item.icon} size={22} /> */}
                  <img src={item.icon} alt={item.text} />
                </span>
                <p>{item.text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ---------------- Mission ---------------- */}
      <section className="tp-section tp-brand-mission">
        <div className="tp-container">
          <h2 className="tp-brand-mission__heading">
            {ourBrand.mission.eyebrow}
          </h2>

          <div className="tp-brand-mission__vision">
            <span className="tp-brand-mission__vision-label">
              <Icon name="leaf" size={14} /> {ourBrand.mission.visionLabel}{" "}
              <Icon name="leaf" size={14} />
            </span>
            <p>{ourBrand.mission.visionText}</p>
          </div>

          <span className="tp-eyebrow tp-brand-mission__label">
            {ourBrand.mission.missionLabel}
          </span>

          <div className="tp-brand-mission__grid">
            {ourBrand.mission.items.map((item) => (
              <div className="tp-brand-mission__card" key={item.text}>
                <span className="tp-brand-mission__icon">
                  <Icon name={item.icon} size={22} />
                </span>
                <p>{item.text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ---------------- Why It Matters ---------------- */}
      <section className="tp-brand-why">
        <div className="tp-container tp-brand-why__grid">
          <div>
            <span className="tp-eyebrow">{ourBrand.whyItMatters.eyebrow}</span>
            <div className="tp-brand-why__row">
              {ourBrand.whyItMatters.items.map((item) => (
                <div className="tp-brand-why__item" key={item.title}>
                  <span>
                    <img src={item.svg} alt="" width={22} height={22} />
                  </span>
                  <p>{item.title}</p>
                </div>
              ))}
            </div>
            <p className="tp-brand-why__note">{ourBrand.whyItMatters.note}</p>
          </div>

          <div className="tp-brand-why__thanks">
            <h3>{ourBrand.thankYou.heading}</h3>
            <p>{ourBrand.thankYou.sub}</p>
            <Link to="/contact" className="tp-btn tp-btn--primary">
              Get in Touch
              <Icon name="arrow" size={16} />
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
